import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { Observable } from 'rxjs/Observable';
import { AuthHttp } from 'angular2-jwt/angular2-jwt';
import { ActivatedRoute, Router } from '@angular/router';
import { Media } from '../model/media.class';
import * as FileSaver from 'file-saver';
import { GridRequest } from '../model/gridRequest.class';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
    selector: 'app-grid',
    templateUrl: './grid.component.html'
})
export class GridComponent {

    public codeIds: string;
    public actIndex = 0;
    public formats: string;

    public message = '';

    constructor(public userService: UserService, private router: Router) {}

    createGrid() {
        this.message = '';
        window.open('/api/grid/' + this.codeIds + '/' + this.formats + '/' + this.userService.user.userId);
    }
}




// WEBPACK FOOTER //
// ./src/app/grid/grid.component.ts